import { render, staticRenderFns } from "./Pollpage.vue?vue&type=template&id=c2d7d942"
import script from "./Pollpage.vue?vue&type=script&lang=js"
export * from "./Pollpage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports